import {useEffect} from 'react';

// Custom hook for debounce
function useDebounce(fn, delay, dependencies = []) {
  useEffect(() => {
    const handler = setTimeout(() => {
      fn();
    }, delay);

    return () => {
      clearTimeout(handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies); // Only re-run if dependencies change
}

export default useDebounce;
